import { BtmReturnInspectionProduct, BtmReturnInspectionStatus } from "../model/btm-return-inspection-product";
import React, { Fragment, useState } from "react";
import { Button, TableBody, TableCell, TableRow, TextField } from "@mui/material";
import { Add, Cancel, Delete, TaskAlt } from "@mui/icons-material";
import { BtmReturnInspectionButton } from "../btm-request-details/btm-return-inspection-button";
import { IUploadedFileDto } from "../../../../common/model/file-exchange-dto";
import { BtmFailedInspectionDialog } from "../btm-failed-inspection-dialog/btm-failed-inspection-dialog";

export const BtmRequestExtraProductsInspection = (
    { list, onAdd, onInspected, onDelete }: {
        list: BtmReturnInspectionProduct[],
        onAdd: (products: BtmReturnInspectionProduct[]) => void,
        onInspected: (index: number, status: BtmReturnInspectionStatus, comment?: string) => void,
        onDelete: (index: number) => void,
    }) => {
    const [inputName, setInputName] = useState("");
    const [inputBarcode, setInputBarcode] = useState("");
    const [inputQuantity, setInputQuantity] = useState("");

    const handleAddProduct = (name: string, barcode: string, quantity: number) => {
        onAdd(Array(parseInt(`${quantity}`, 0)).fill(0).map(_ => BtmReturnInspectionProduct.fromForm(barcode, name)));

        setInputName("");
        setInputBarcode("");
        setInputQuantity("");
    };

    return <TableBody>
        {list.map((product, index) =>
            <BtmRequestExtraProductInspection data={product} index={index}
                                              onInspectionCompleted={onInspected} onDelete={onDelete} />)}
        <TableRow>
            <TableCell>
                <TextField fullWidth value={inputName} onChange={event => setInputName(event.target.value)} />
            </TableCell>
            <TableCell>
                <TextField value={inputBarcode} onChange={event => setInputBarcode(event.target.value)} />
            </TableCell>
            <TableCell>
                <TextField value={inputQuantity} type={"number"} sx={{ width: "80px" }}
                           onChange={event => setInputQuantity(event.target.value)} />
            </TableCell>
            <TableCell>
                <Button color={"primary"} variant={"outlined"} startIcon={<Add />}
                        onClick={() => handleAddProduct(inputName, inputBarcode, parseInt(inputQuantity, 0))}
                        disabled={!inputName || !inputBarcode || !inputQuantity}>
                    Add
                </Button>
            </TableCell>
        </TableRow>
    </TableBody>;
};

const BtmRequestExtraProductInspection = (
    { data, index, onInspectionCompleted, onDelete }: {
        data: BtmReturnInspectionProduct,
        index: number,
        onInspectionCompleted: (index: number, inspectionResult: BtmReturnInspectionStatus,
                                comment?: string, files?: IUploadedFileDto[]) => void,
        onDelete: (index: number) => void,
    }) => {
    const [isFailedInspectionDialogOpen, setIsFailedInspectionDialogOpen] = useState(false);
    const [failedInspectionDialogStatus, setFailedInspectionDialogStatus] = useState<BtmReturnInspectionStatus>(BtmReturnInspectionStatus.None);

    const handleInspectionDetailsDialogOpen = (status: BtmReturnInspectionStatus) => {
        setIsFailedInspectionDialogOpen(true);
        setFailedInspectionDialogStatus(status);
    };

    const handleFailedInspectionComplete = (comment: string, files: IUploadedFileDto[]) => {
        onInspectionCompleted(index, failedInspectionDialogStatus, comment, files);
        setIsFailedInspectionDialogOpen(false);
    };

    return <Fragment>
        {isFailedInspectionDialogOpen &&
            <BtmFailedInspectionDialog data={data} status={failedInspectionDialogStatus}
                                       onComplete={handleFailedInspectionComplete}
                                       onClose={() => setIsFailedInspectionDialogOpen(false)} />}
        <TableRow key={index}>
            <TableCell>{data.productName}</TableCell>
            <TableCell>{data.barcode}</TableCell>
            <TableCell>x 1</TableCell>
            <TableCell>
                <BtmReturnInspectionButton color={"success"}
                                           isSelected={data.status === BtmReturnInspectionStatus.Accepted}
                                           onClick={() => onInspectionCompleted(index, BtmReturnInspectionStatus.Accepted)}>
                    <TaskAlt />
                </BtmReturnInspectionButton>
                <BtmReturnInspectionButton color={"error"}
                                           isSelected={data.status === BtmReturnInspectionStatus.Refused}
                                           onClick={() => handleInspectionDetailsDialogOpen(BtmReturnInspectionStatus.Refused)}>
                    <Cancel />
                </BtmReturnInspectionButton>
                <Button color={"secondary"} size={"medium"} onClick={() => onDelete(index)} variant={"outlined"}>
                    <Delete />
                </Button>
            </TableCell>
        </TableRow>
    </Fragment>;
};
